var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
var MaleIcon = function (props) { return (React.createElement(SvgIcon, __assign({}, props),
    React.createElement("path", { fillRule: "evenodd", d: "M18.9202468,10.2114944 L18.9202468,5 L13.7087339,5 L15.6484492,6.93971534 L13.6869606,8.90116693 C12.789344,8.26742442 11.6940813,7.89499878 10.5117438,7.89499878 C7.46768585,7.89499878 5,10.3627032 5,13.4067426 C5,16.4507821 7.46770437,18.9184865 10.5117438,18.9184865 C13.5557833,18.9184865 16.0234877,16.4508006 16.0234877,13.4067426 C16.0234877,12.2906887 15.6914585,11.2523331 15.1212385,10.3844209 L17.107243,8.39850905 L18.9202468,10.2114944 Z M10.5117438,17.1779367 C8.4289917,17.1779367 6.74054971,15.4894947 6.74054971,13.4067426 C6.74054971,11.3239905 8.4289917,9.63554849 10.5117438,9.63554849 C12.594496,9.63554849 14.282938,11.3239905 14.282938,13.4067426 C14.282938,15.4894947 12.594496,17.1779367 10.5117438,17.1779367 Z" }))); };
export default MaleIcon;
